import { BodyLong } from "@navikt/ds-react";

const InfoTilArbeidsgiver = () => {
  return (
    <BodyLong>
      For deg som er arbeidsgiver, vil referat være tilgjengelig i fire måneder
      etter at den siste sykmeldingen er over. Du kan laste referatet ned som en
      PDF hvis du ønsker å beholde det lenger.
    </BodyLong>
  );
};

export default InfoTilArbeidsgiver;
